import { useMatches } from 'react-router-dom';

/**
 * How AppLayout places a page: `contained` wraps it in PageContainer, `full-width` renders it bare
 * (the page places its own), `fill-height` wraps it in a PageContainer that fills the main region.
 */
export type PageLayout = 'contained' | 'full-width' | 'fill-height';

/** Route `handle` fields AppLayout reads. */
export interface AppRouteHandle {
    pageLayout?: Exclude<PageLayout, 'contained'>;
}

export const FULL_WIDTH_PAGE: AppRouteHandle = { pageLayout: 'full-width' };
export const FILL_HEIGHT_PAGE: AppRouteHandle = { pageLayout: 'fill-height' };

/** The deepest matched route carrying a `pageLayout` wins. */
export function usePageLayout(): PageLayout {
    const matches = useMatches();
    for (let index = matches.length - 1; index >= 0; index--) {
        const layout = (matches[index].handle as AppRouteHandle | undefined)?.pageLayout;
        if (layout) return layout;
    }
    return 'contained';
}
